'use es6';

export const CONTACT = 'CONTACT';
export const COMPANY = 'COMPANY';
export const DEAL = 'DEAL';
export const MARKETING_EVENT = 'MARKETING_EVENT';
export const PRODUCT = 'PRODUCT';
export const QUOTE = 'QUOTE';
export const TICKET = 'TICKET';
export const RESTRICTED_STANDARD_OBJECTS = ['CONTACT', 'COMPANY', 'DEAL', 'QUOTE', 'TICKET'];